import invalidLinkImg from '../../public/invalid-link.svg'
import { Button } from 'antd'
import { MainLayout } from '../components/MainLayout'
import { useNavigate } from 'react-router-dom'

const ErrorPage = () => {
    const navigate = useNavigate()

    return (
        <MainLayout>
            <img className="mt1" src={invalidLinkImg.toString()} alt="mrs logo" />
            <h2 className="t-center danger-color m0 mt1">404</h2>
            <h2 className="t-center danger-color">silahkan periksa tautan anda dengan benar.</h2>

            <Button
                className="btn-submit"
                size="large"
                type="primary"
                htmlType="submit"
                onClick={() => navigate(-1)}
            >
                Back
            </Button>
        </MainLayout>
    )
}

export default ErrorPage
